import { Component, OnInit, ViewChild } from "@angular/core";
import { MatPaginator } from "@angular/material/paginator";
import { DataSourceResponse, Invite, InvitesService } from "@meddatacore/shared";
import { BehaviorSubject, Subject } from "rxjs";
import { debounceTime, distinctUntilChanged, finalize } from "rxjs/operators";


@Component({
    selector: 'app-invite-list',
    templateUrl: './invite-list.component.html',
    styleUrls: ['./invite-list.component.scss']
})
export class InviteListComponent implements OnInit {
    dataSource$: Subject<DataSourceResponse<Invite>> = new BehaviorSubject(DataSourceResponse.default());
    loading$: Subject<boolean> = new BehaviorSubject(false);
    displayedColumns = [
        "type",
        "createdAt",
        "status",
        "actions"
    ];

    @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;

    constructor(
        private invitesService: InvitesService) {

    }

    ngOnInit() {
        this.loadData();
    }

    loadData() {
        const page = this.paginator.pageIndex + 1;
        const pageSize = this.paginator.pageSize || 10;
        this.loading$.next(true);
        this.invitesService.getInvites(page, pageSize)
            .pipe(
                debounceTime(200),
                distinctUntilChanged(),
                finalize(() => this.loading$.next(false))
            )
            .subscribe(a => {
                this.dataSource$.next(a);
            });
    }

    onRefresh() {
        this.loadData();
    }

    onChangePage() {
        this.loadData();
    }
}